'use client';

import {useDevConfig} from 'common/dev';
import type {SubmissionFlowConfig, TakeHomeFile} from 'iq-interview_experiences/types';
import {FlowStepTakehome} from './flow_step_takehome';
import {FlowStepQuestionsAndTakehome} from './flow_step_questions_and_takehome';

export type FlowStepQuestionsAndTakehomeResolverProps = {
  step: number;
  totalSteps: number;
  config: SubmissionFlowConfig;
  questions: string;
  onQuestionsChange: (v: string) => void;
  validationError: string | null;
  takeHomeFiles: TakeHomeFile[];
  onAddTakehomeFiles: (files: File[]) => void;
  onRemoveTakehomeFile: (id: string) => void;
};

export function FlowStepQuestionsAndTakehomeResolver({
  step,
  totalSteps,
  config,
  questions,
  onQuestionsChange,
  validationError,
  takeHomeFiles,
  onAddTakehomeFiles,
  onRemoveTakehomeFile,
}: FlowStepQuestionsAndTakehomeResolverProps) {
  const {structuredQuestions} = useDevConfig();

  if (config.forceTakeHomeOnly) {
    return (
      <FlowStepTakehome
        step={step}
        totalSteps={totalSteps}
        validationError={validationError}
        takeHomeFiles={takeHomeFiles}
        onAddTakehomeFiles={onAddTakehomeFiles}
        onRemoveTakehomeFile={onRemoveTakehomeFile}
      />
    );
  }

  return (
    <FlowStepQuestionsAndTakehome
      step={step}
      totalSteps={totalSteps}
      value={questions}
      onChange={onQuestionsChange}
      validationError={validationError}
      allowTakehome={config.allowTakeHome}
      useStructured={config.allowStructuredQuestions || structuredQuestions}
      takeHomeFiles={takeHomeFiles}
      onAddTakehomeFiles={onAddTakehomeFiles}
      onRemoveTakehomeFile={onRemoveTakehomeFile}
    />
  );
}
